import { z } from 'zod'
import { PaymentType, PaymentDataLayerSku, PaymentDataLayerName } from '@/types'

export const paymentInfoForDataLayerSchema = z.object({
  transactionId: z.number().nullish(),
  amount: z.number().nullish(),
  typeOfSupport: z.nativeEnum(PaymentType),
  installmentID: z.number()
})

export const paymentInfoForGtmSchema = z.object({
  event: z.literal('indeks_podziekowanie'),
  transactionId: z.number().nullish(),
  transactionAffiliation: z.literal('Stowarzyszenie Wiosna'),
  transactionTotal: z.number(),
  transactionTax: z.literal(0),
  transactionShipping: z.literal(0),
  transactionProducts: z.array(
    z.object({
      sku: z.nativeEnum(PaymentDataLayerSku),
      name: z.nativeEnum(PaymentDataLayerName),
      category: z.literal('AP'),
      price: z.number(),
      quantity: z.literal(1),
      installmentID: z.number()
    })
  )
})
